import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { FormatMessage } from '../core/FormatMessage';
import { itemConfirmationMessages } from './confirmationMessages';

export const ItemCostConfirmation = ({
    quantity,
    amount,
    currency,
    lineItemDiscount,
    perCardDiscount,
    shippingGroup,
    deliveryMethod,
    productPurchaseFeeAmount,
}) => (
    <Fragment>
        <FormatMessage
            intlMessage={itemConfirmationMessages.quantity}
            values={{ quantity }}
            className="item-confirmation-quantity"
        />
        <FormatMessage
            intlMessage={itemConfirmationMessages.amount}
            values={{
                amount: <FormattedNumber style="currency" currency={currency || 'USD'} value={amount} />
            }}
            className="item-confirmation-amount"
        />
        { lineItemDiscount > 0 && (
            <FormatMessage
                intlMessage={itemConfirmationMessages.discount}
                values={{
                    discount: <FormattedNumber style="currency" currency={currency || 'USD'} value={perCardDiscount} />,
                    quantity: Math.floor(lineItemDiscount / perCardDiscount), 
                }}
                className="item-confirmation-promotion"
            />
        )}
        {deliveryMethod === 'PHYSICAL' && (
            <FormatMessage
                intlMessage={itemConfirmationMessages.shippingCost}
                values={{
                    amount: (
                        <FormattedNumber
                            style="currency"
                            currency={currency}
                            value={shippingGroup.shippingMethod.shippingAmount}
                        />
                    )
                }}
                className="item-confirmation-shipping-cost"
            />
        )}

        {productPurchaseFeeAmount && (
            <FormatMessage
                intlMessage={itemConfirmationMessages.productPurchaseFee}
                values={{
                    fee: (
                        <FormattedNumber
                            style="currency"
                            currency={currency || 'USD'}
                            value={productPurchaseFeeAmount}
                        />
                    )
                }}
                className="item-confirmation-fee-amount"
            />
        )}
    </Fragment>
);

ItemCostConfirmation.propTypes = {
    quantity: PropTypes.number,
    amount: PropTypes.number,
    currency: PropTypes.string,
    lineItemDiscount: PropTypes.number,
    perCardDiscount: PropTypes.number,
    shippingGroup: PropTypes.shape({
        shippingMethod: PropTypes.shape({
            shippingAmount: PropTypes.number,
        }),
    }),
    deliveryMethod: PropTypes.string,
    productPurchaseFeeAmount: PropTypes.any,
};

ItemCostConfirmation.defaultProps = {
    quantity: 0,
    amount: 0,
    currency: 'USD',
    lineItemDiscount: 0,
    perCardDiscount: 0,
    shippingGroup: { shippingMethod: {} },
    deliveryMethod: '',
    productPurchaseFeeAmount: null,
};

export default ItemCostConfirmation;